import { useLocation } from "react-router-dom";
import CONSTANT from "../constants/Constant";
import useHandlePayment from "./useHandlePayment";

const usePaymentAndD2CRedirection = () => {
    const location = useLocation();
    const { handlePay } = useHandlePayment();

    const isValidUrlForD2C = () => {
        let query = new URLSearchParams(location?.search);
        let priceFromUrl = query.get(CONSTANT.QUERY_PARAM.PRICE) || '';
        let assessmentNameFromUrl = query.get(CONSTANT.QUERY_PARAM.ASSESSMENT_NAME) || '';
        let packageIdFromUrl = query.get(CONSTANT.QUERY_PARAM.PACKAGE_ID) || '';
        let bodyRegionIdsFromUrl = query.get(CONSTANT.QUERY_PARAM.BODY_REGION_IDS) || '';

        let bodyRegionList = bodyRegionIdsFromUrl.split(',').map(Number).filter(Boolean) || [];

        let isPriceFromUrlNotEmpty = priceFromUrl !== '';
        let isPriceFromUrlNotZero = priceFromUrl !== '0';
        let isPriceFromUrlNotNaN = !isNaN(priceFromUrl);
        let isAssessmentNameFromUrlNotEmpty = assessmentNameFromUrl !== '';
        let isPackageIdFromUrlNotEmpty = packageIdFromUrl !== '';
        let isBodyRegionIdsFromUrlNotEmpty = bodyRegionIdsFromUrl !== '';
        let isBodyRegionListNotEmpty = bodyRegionList.length > 0;
        let isBodyRegionListLengthGreaterThanOrEqualToOne = bodyRegionList.length >= 1;

        if(isPriceFromUrlNotEmpty &&
            isPriceFromUrlNotZero &&
            isPriceFromUrlNotNaN &&
            isAssessmentNameFromUrlNotEmpty &&
            isPackageIdFromUrlNotEmpty &&
            isBodyRegionIdsFromUrlNotEmpty &&
            isBodyRegionListNotEmpty &&
            isBodyRegionListLengthGreaterThanOrEqualToOne)
        {
            return true;
        }

        return false;
    }

    const handleRedirectToStripe = async () => {
        let isRedirected = false;

        let query = new URLSearchParams(location?.search);
        let packageId = query.get(CONSTANT.QUERY_PARAM.PACKAGE_ID) || '';
        let bodyRegionListParam = query.get(CONSTANT.QUERY_PARAM.BODY_REGION_IDS) || '';
        let assessmentNameFromUrl = query.get(CONSTANT.QUERY_PARAM.ASSESSMENT_NAME) || '';
        let orderId = query.get(CONSTANT.QUERY_PARAM.ORDER_ID) || '';

        let bodyRegionList = bodyRegionListParam.split(',').map(Number).filter(Boolean) || [];

        if(!packageId || !bodyRegionList.length || !assessmentNameFromUrl) {
            return isRedirected;
        }

        await handlePay(packageId, bodyRegionList, assessmentNameFromUrl, orderId);
        isRedirected = true;

        return isRedirected;
    }

    return {
        isValidUrlForD2C,
        handleRedirectToStripe
    }
}

export default usePaymentAndD2CRedirection;
